import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Z from "../core/zIndex";
import {ShowerTubCombo} from "../core/parts/showerTubCombo";
import {Vanity} from "../core/parts/vanity";
import {Shower} from "../core/parts/shower";
import Walls from "../core/parts/walls";
import {VanityTypes, ShowerComboTubType} from "../core/constants";
import {getMetadataByDimensions, reorder} from "../../../misc/utils";
import Analytics from "../../../analytics";

import {getCurrentLayout} from "../../appLayout";
import {ShowerAccessories} from "../core/parts/showerAccessories";

export default class ContextMenu extends Component {

  static propTypes = {
    designNavigationItems: PropTypes.array,
    contextMenuOpen: PropTypes.string,
    hoveredLayer: PropTypes.object,
    handleContextMenuClick: PropTypes.func,
    contextMenuPosition: PropTypes.object,
    contextMenuPonyWall: PropTypes.bool,
    renderGreenLayerByZindex: PropTypes.func,
    closeContextMenu: PropTypes.func,
  };

  state = {
    contextMenuButtons: []
  };

  componentDidMount() {
    this.setContextMenuButtons();
    if (this.props.closeContextMenu) {
      document.addEventListener('click', this.contextMenuBlur)
    }
  }

  contextMenuBlur = (e) => {
    if (!e.target.closest('.contextmenu-buttons')
      && !e.target.closest('.contextmenu-buttons__button')
      && !e.target.closest('.sprocket-container') && !e.target.closest('.canvas')) {
      this.props.closeContextMenu();
    }
  };

  componentWillUnmount() {
    if (this.props.closeContextMenu) {
      document.removeEventListener('click', this.contextMenuBlur)
    }
  }

  getShowerBodySelectionButtons = () => {
    const shower = this.state.designNavigationItems.find(desItem => desItem.text === "Shower");
    const currentShowerSize = shower.part.showerSize();
    const showerBody = shower && shower.part.showerBody;
    return (showerBody && showerBody.features.length) ? showerBody.features.filter((showerBodyFeature) => {
      return showerBodyFeature.partName.includes(currentShowerSize);
    }) : [1]
  };

  setShowerBodySelectionButtons = () => {
    const layout = getCurrentLayout();
    const shower = layout.parts[Shower.id];
    const vanity = layout.parts[Vanity.id];
    const counterTopSize = vanity.counterTopSize();
    const showerTubCombo = layout.parts[ShowerTubCombo.id];

    const showerSubParts = shower.subParts();
    const showerBody = showerSubParts.find((menuItem) => {
      return menuItem.part.partId === "shower_body"
    });
    const currentShowerSize = shower.showerSize();
    let contextMenuButtons = [];

    if (showerTubCombo.showerTubComboIsActive) {
      const showerTubComboSubParts = showerTubCombo.subParts();
      const wallConfiguration = showerTubComboSubParts.find((menuItem) => {
        return menuItem.part.partId === "wall_configuration"
      });
      showerTubCombo.wallConfiguration.features.forEach((wallConfigurationFeature) => {
        contextMenuButtons.push(Object.assign({}, wallConfiguration, {
          subMenuParent: "Walls",
          subMenuText: wallConfigurationFeature.partName,
          bgImageText: wallConfigurationFeature.partName,
          clickFeature: true,
          text: wallConfigurationFeature.partName.includes("Pony") ? "Pony Wall" : "Left Shower Wall"
        }))
      })
    } else if (showerBody && showerBody.part.features.length) {
      showerBody.part.features.forEach((showerBodyFeature) => {
        if (showerBodyFeature.partName.includes(currentShowerSize)) {
          // console.log('showerBodyFeature.partName', showerBodyFeature.partName);
          if (!(counterTopSize === "72in" && layout.type === 1 && showerBodyFeature.partName.includes("15X4"))) {
            contextMenuButtons.push(Object.assign({}, showerBody, {
              subMenuParent: "Walls",
              subMenuText: showerBodyFeature.partName,
              bgImageText: showerBodyFeature.partName,
              clickFeature: true,
              text: showerBodyFeature.partName.includes("Pony") ? "Pony Wall" : "Left Shower Wall"
            }))
          }
        }
      })
    }

    const clickedItemIndex = contextMenuButtons.findIndex(item => {
      return showerTubCombo.showerTubComboIsActive
        ? item.subMenuText === showerTubCombo.wallConfiguration.activeFeature.partName
        : item.subMenuText === showerBody.part.activeFeature.partName
    });

    if (clickedItemIndex > 0) {
      contextMenuButtons = reorder(contextMenuButtons, clickedItemIndex, 0); // swap items in array start
    }

    this.setState({
      contextMenuButtons
    })
  };

  setWallBButtons = () => {
    const layout = getCurrentLayout();
    let contextMenuButtons = [];

    const wallParent = layout.parts[Walls.id];
    const wallParts = wallParent.subParts().filter((menuItem) => menuItem.part.partId === "right_wall");
    wallParts.forEach((wallPart) => {
      contextMenuButtons.push(Object.assign({}, wallPart, {
        subMenuParent: "Walls",
        subMenuText: wallPart.part.partName,
        bgImageText: wallPart.part.partName,
        text: wallPart.text
      }));
    });

    const vanity = layout.parts[Vanity.id];
    const vanityBacksplash = vanity.subParts().find((menuItem) => {
      return menuItem.part.partId === "vanity_backsplash"
    });
    if (vanityBacksplash) {
      contextMenuButtons.push(Object.assign({}, vanityBacksplash, {
        subMenuParent: "Vanity",
        subMenuText: vanityBacksplash.part.partName,
        bgImageText: vanityBacksplash.part.partName,
        text: vanityBacksplash.text
      }));
    }

    let zIndexToFind = this.props.hoveredLayer.zIndex;

    const clickedItem = contextMenuButtons.find(item => {
      return item.part.activeFeature && item.part.activeFeature.layer && item.part.activeFeature.layer.zIndex === zIndexToFind;
    });
    if (clickedItem && clickedItem.part && clickedItem.part.partId === "vanity_backsplash") {
      const vanityFaucet = vanity.subParts().find((menuItem) => {
        return menuItem.part.partId === "vanity_faucet"
      });
      if (vanityFaucet) {
        contextMenuButtons.push(Object.assign({}, vanityFaucet, {
          subMenuParent: "Vanity",
          subMenuText: vanityFaucet.part.partName,
          bgImageText: vanityFaucet.part.partName,
          text: vanityFaucet.text
        }));
      }
    }

    const clickedItemIndex = contextMenuButtons.findIndex(item => {
      return item.part.activeFeature && item.part.activeFeature.layer && item.part.activeFeature.layer.zIndex === zIndexToFind;
    });

    if (clickedItemIndex > 0) {
      contextMenuButtons = reorder(contextMenuButtons, clickedItemIndex, 0); // swap items in array start
    }

    this.setState({
      contextMenuButtons
    })
  };

  setContextMenuButtons() {

    const layout = getCurrentLayout();

    if (this.props.contextMenuOpen === "Shower Body Selection") {
      this.setShowerBodySelectionButtons();
      return
    } else if (this.props.contextMenuOpen === "wall_b_custom") {
      this.setWallBButtons();
      return
    }

    const hoveredParent = this.props.designNavigationItems.find(navItem => {
      return navItem.text === this.props.contextMenuOpen
    });

    let relatedItems = hoveredParent.part.relatedItems;
    if (this.props.contextMenuOpen === "Shower Tub Combo") {
      relatedItems = [...hoveredParent.part.relatedItems, ...hoveredParent.part.getShowerRelatedItems()]
    }

    let zIndexToFind = this.props.hoveredLayer.zIndex;
    if (this.props.hoveredLayer.zIndex === Z.layouts[layout.getCurrentLayoutName()].Shower.Wall2) {
      zIndexToFind = Z.layouts[layout.getCurrentLayoutName()].Shower.Wall
    }
    if (
      this.props.hoveredLayer.zIndex === Z.layouts[layout.getCurrentLayoutName()].Shower.WallAccent2
    ) {
      zIndexToFind = Z.layouts[layout.getCurrentLayoutName()].Shower.WallAccent
    }
    const clickedItem = relatedItems.find((item) => {
      return (item.activeFeature && item.activeFeature.layer.zIndex === zIndexToFind)
        || (item.layerPositions && Object.keys(item.layerPositions).some(key => {
          return item.layerPositions[key] && item.layerPositions[key].layer && (item.layerPositions[key].layer.zIndex === zIndexToFind)
        }))
    });

    let itemsToRender = this.getItemsToRender(hoveredParent);

    // console.log('clickedItem', clickedItem);
    // console.log('relatedItems', relatedItems);
    // console.log('itemsToRender', itemsToRender);

    const clickedItemIndex = itemsToRender.findIndex(item => item.text === clickedItem.partName);
    if (clickedItemIndex > 0) {
      itemsToRender = reorder(itemsToRender, clickedItemIndex, 0); // swap items in array start
    }

    this.setState({
      contextMenuButtons: itemsToRender
    })
  }

  getItemsToRender = (hoveredParent) => {
    const layout = getCurrentLayout();
    let itemsToRender = hoveredParent.part.subParts().filter(subPart => layout.designNavigationItems(subPart).length);

    if ((this.props.contextMenuOpen === "Shower" || this.props.contextMenuOpen === "Shower Tub Combo") && hoveredParent.text !== "Shower Accessories") {
      itemsToRender = itemsToRender.filter(menuButton => {
        return this.props.contextMenuPonyWall
          ? menuButton.part.isPonyWallPart && menuButton.part.partId !== "pony_wall"
          : !menuButton.part.isPonyWallPart
      });
      const accessoriesParent = layout.parts[ShowerAccessories.id];
      if (accessoriesParent && accessoriesParent.categoryEnabled && !this.props.contextMenuPonyWall
        && accessoriesParent.subParts().some(subPart => layout.designNavigationItems(subPart).length)) {
        itemsToRender = itemsToRender.filter(menuButton => menuButton.part.partId !== "shower_wall_accent");
        itemsToRender.push({
          text: "Accessories",
          part: {},
          subNav: true
        })
      }
      itemsToRender = itemsToRender.filter(menuButton => menuButton.part.partId !== "shower_head");
      if (layout.parts[ShowerTubCombo.id] && !this.props.contextMenuPonyWall) {
        itemsToRender.push({
          text: "Configure Layout",
          part: {},
          subNav: true
        })
      }
    }

    if (this.props.contextMenuOpen === "Shower") {
      itemsToRender = itemsToRender.filter(menuButton => menuButton.part.partId !== "threshold");
    }
    if (this.props.contextMenuOpen === "Shower Tub Combo") {
      itemsToRender = this.removeNotUsedTubItemsFromContextMenu(itemsToRender, hoveredParent.part.bottomTub);
    }
    if (this.props.contextMenuOpen === "Vanity") {
      itemsToRender = itemsToRender.filter((itemToRender) => {
        return itemToRender.part.partId !== "vanity_mirror" && itemToRender.part.partId !== "vanity_backsplash";
      });
    }

    return itemsToRender
  };

  removeNotUsedTubItemsFromContextMenu = (itemsToRender, activeTub) => {
    return itemsToRender.filter((itemToRender) => {
      let keepThisItem = true;
      Object.keys(ShowerComboTubType).forEach((key) => {
        if (itemToRender.part.partId === ShowerComboTubType[key] && itemToRender.part.partId !== activeTub
          && itemToRender.part.partId !== ShowerComboTubType.replacement_tub
          && itemToRender.part.partId !== ShowerComboTubType.bathtub_liner
        ) {
          keepThisItem = false
        }
      });
      if (itemToRender.text === "Wall Configuration") {
        keepThisItem = false
      }
      return keepThisItem
    });
  };

  handleSubNavClick = (menuItem) => {
    const layout = getCurrentLayout();

    if (menuItem.text === "Accessories") {
      const hoveredParent = this.props.designNavigationItems.find(navItem => {
        return navItem.text === "Shower Accessories"
      });
      this.setState({
        contextMenuButtons: this.getItemsToRender(hoveredParent)
          .map(button => {
            button.subMenuParent = "Shower Accessories";
            return button
          })
      });
      return false
    }

    const showerSubParts = layout.parts[Shower.id].subParts();

    const shower = showerSubParts.find((menuItem) => {
      return menuItem.part.partId === "shower_body"
    });
    shower.subMenuText = "Shower";
    shower.subMenuParent = "Shower";

    const showerTubCombo = layout.parts[ShowerTubCombo.id];
    const showerTubComboSubParts = showerTubCombo.subParts();

    const activeTubMenuItems = showerTubComboSubParts.filter(menuItem => menuItem.part.bottomTubId);
    activeTubMenuItems.forEach(menuItem => menuItem.subMenuParent = "Shower Tub Combo");

    const wallConfiguration = showerTubComboSubParts.find((menuItem) => {
      return menuItem.part.partId === "wall_configuration"
    });
    wallConfiguration.subMenuText = "Shower Tub Combo";
    wallConfiguration.subMenuParent = "Shower Tub Combo";

    this.setState({
      contextMenuButtons: [
        shower,
        wallConfiguration,
        ...activeTubMenuItems,
      ]
    })
  };

  handleContextMenuHover = (menuItem) => {
    const layout = getCurrentLayout();
    const hoveredButton = menuItem.text === "Countertop" ? "CounterTop" : menuItem.text;
    const hoveredParent = menuItem.subMenuParent || this.props.contextMenuOpen;

    const layoutType = layout.getCurrentLayoutName();

    // console.log('hoveredButton', hoveredButton);
    // console.log('hoveredParent', hoveredParent);

    if (hoveredButton && hoveredParent) {

      let hoveredZindex = "";

      if (hoveredParent === "Shower") {
        const shower = layout.parts.Shower;
        switch (hoveredButton) {
          case "Shower Walls":
            hoveredZindex = Z.layouts[layoutType].Shower.Wall;
            break;
          case "Shower Body":
            if (shower.showerDoor && shower.showerDoor.features.length) {
              hoveredZindex = Z.layouts[layoutType][hoveredParent].ShowerDoor;
            } else {
              hoveredZindex = Z.layouts[layoutType][hoveredParent].Glass;
            }
            break;
          case "Shower Door":
            hoveredZindex = Z.layouts[layoutType][hoveredParent].ShowerDoor;
            break;
          case "Handle":
            hoveredZindex = Z.layouts[layoutType][hoveredParent].ShowerDoorHandle;
            break;
          case "Shower Pan":
          case "Shower Pans":
            hoveredZindex = Z.layouts[layoutType][hoveredParent].ShowerPanCombo;
            break;
          case "Shower Walls Accent":
            hoveredZindex = Z.layouts[layoutType][hoveredParent].WallAccent;
            break;
          case "Pony Wall Glass":
            hoveredZindex = Z.layouts[layoutType]["Shower"].PonyWallGlass;
            break;
          case "Pony Wall Cap":
            hoveredZindex = Z.layouts[layoutType]["Shower"].PonyWallCap;
            break;
          case "Floor":
            hoveredZindex = shower.showerFloorIsActive
              ? Z.layouts[layoutType][hoveredParent][hoveredButton]
              : Z.layouts[layoutType][hoveredParent].ShowerPanCombo;
            break;
          default:
            hoveredZindex = Z.layouts[layoutType][hoveredParent][hoveredButton];
            break;
        }
      } else if (hoveredParent === "Shower Tub Combo") {
        switch (hoveredButton) {
          case "Shower Door":
            hoveredZindex = Z.layouts[layoutType].Shower.ShowerDoor;
            break;
          case "Shower Walls":
            hoveredZindex = Z.layouts[layoutType].Shower.Wall;
            break;
          case "Shower Walls Accent":
            hoveredZindex = Z.layouts[layoutType].Shower.WallAccent;
            break;
          case "Fixture":
            hoveredZindex = Z.layouts[layoutType]["Shower"].Fixture;
            break;
          case "Handle":
            hoveredZindex = Z.layouts[layoutType]["Shower"].ShowerDoorHandle;
            break;
          case "Wall Configuration":
            hoveredZindex = Z.layouts[layoutType]["Shower"].ShowerDoor;
            break;
          case "Jetted Tub":
            hoveredZindex = Z.layouts[layoutType]["Shower"].TubCombo.JettedTub;
            break;
          case "Tub Liner":
            hoveredZindex = Z.layouts[layoutType]["Shower"].TubCombo.Liner;
            break;
          case "Walk In Tub":
            hoveredZindex = Z.layouts[layoutType]["Shower"].TubCombo.WalkInTub;
            break;
          case "Replacement Tub":
            hoveredZindex = Z.layouts[layoutType]["Shower"].TubCombo.ReplacementTub;
            break;
          case "Pony Wall Glass":
            hoveredZindex = Z.layouts[layoutType]["Shower"].PonyWallGlass;
            break;
          case "Pony Wall Cap":
            hoveredZindex = Z.layouts[layoutType]["Shower"].PonyWallCap;
            break;
          default:
            hoveredZindex = Z.layouts[layoutType]["Shower"].TubCombo[hoveredButton.replace(/ /g, "")];
            break;
        }
      } else if (hoveredParent === "Vanity") { // Vanity
        if (layout.parts.Vanity.activeSubType_ === VanityTypes.Complete) {
          switch (hoveredButton) {
            case "Vanity":
              hoveredZindex = Z.layouts[layoutType].Vanity.Complete.Cabinet;
              break;
            case "Accent Wall":
              hoveredZindex = Z.layouts[layoutType].Wall_A_Accent_Mask;
              break;
            default:
              hoveredZindex = Z.layouts[layoutType].Vanity[hoveredButton]; // Mirror
              break;
          }
        } else {
          switch (hoveredButton) {
            case "Accent Wall":
              hoveredZindex = Z.layouts[layoutType].Wall_A_Accent_Mask;
              break;
            case "Backsplash":
              hoveredZindex = Z.layouts[layoutType].Vanity.VanityBacksplash;
              break;
            default:
              hoveredZindex = Z.layouts[layoutType].Vanity[hoveredButton];
              break;
          }
        }
      } else if (hoveredParent === "Bathtub") { // Bathtub
        if (hoveredButton === "Bathtub") {
          hoveredZindex = Z.layouts[layoutType].Bathtub.BathTubBody
        } else if (hoveredButton === "Fixture") {
          hoveredZindex = Z.layouts[layoutType].Bathtub.BathTubFixture
        } else {
          hoveredZindex = Z.layouts[layoutType].Bathtub[hoveredButton]
        }
      } else if (hoveredParent === "Walls") { // Bathtub
        switch (hoveredButton) {
          case "Pony Wall":
            hoveredZindex = Z.layouts[layoutType].Shower.PonyWall;
            break;
          case "Left Shower Wall": {
            const wallParent = layout.parts[hoveredParent];
            const activeShowerGroup = wallParent.getActiveShowerGroup();
            const showerDimensions = getMetadataByDimensions(activeShowerGroup.showerDimensions());
            hoveredZindex = showerDimensions === "Half"
              ? Z.layouts[layoutType].Shower.ExtrusionWallLeftHalfWall
              : Z.layouts[layoutType].Shower.ExtrusionWallLeft;
            break;
          }
          default:
            hoveredZindex = Z.layouts[layoutType].Vanity[hoveredButton];
            break;
        }
      }

      this.props.renderGreenLayerByZindex(hoveredZindex);
    }

  };

  render() {

    let contextMenuStyles = this.props.contextMenuPosition || {};
    if (this.state.contextMenuButtons.length === 4) {
      contextMenuStyles = Object.assign({}, contextMenuStyles, {maxWidth:"210px"} )
    }

    return (
      <div className="contextmenu" style={contextMenuStyles}>
        <div className="contextmenu-buttons">
          {this.state.contextMenuButtons.map((menuItem) => {
            return menuItem ? (
              <button key={menuItem.subMenuText || menuItem.text}
                      onClick={menuItem.subNav
                        ? () => this.handleSubNavClick(menuItem)
                        : () => {
                        Analytics.sendClickEvent('context-menu-' + menuItem.text);
                        this.props.handleContextMenuClick(menuItem);
                      }}
                      data-parent={this.props.contextMenuOpen}
                      onMouseOver={this.props.renderGreenLayerByZindex ? () => this.handleContextMenuHover(menuItem) : () => {}}
                      className={"contextmenu-buttons__button contextmenu-buttons__button--"
                      +(menuItem.bgImageText || menuItem.text).toLowerCase().replace(/ /g,"-")}>
                {menuItem.text === "Configure Layout" ? (
                  <div className="sprocket-container">
                    <div className="sprocket small spin reverse"/>
                    <div className="sprocket large spin"/>
                  </div>
                ) : null}
                <span className="contextmenu-buttons__button-text">{menuItem.subMenuText || menuItem.text}</span>
              </button>
            ) : null
          })}
        </div>
      </div>
    )
  }
}
